const {
  services,
  refreshTokenCookieName,
  jwtCookieName,
  sentryLogging,
  productFruitsEnabled,
} = window.env

export const ROUTES = { HOME: '/' }

export const LOGGING: boolean = Boolean(sentryLogging)
export const PRODUCT_FRUITS_ENABLED: boolean = Boolean(productFruitsEnabled)

export const SENTRY_SERVICE: string = services.sentryDSN
export const SENTRY_ENVIRONMENT: string = services.sentryEnv
export const AUTH_SERVICE: string = services.auth
export const BIZ_SERVICE: string = services.biz
export const HOST_SERVICE: string = services.host
export const LOGIN_SERVICE: string = services.login
export const HEADBOX_ROOT_SERVICE: string = services.root
export const ASSET_SERVICE: string = services.assets
export const S3_IMAGE_PATH: string = services.S3ImagePath
export const CDN_IMAGE_PATH: string = services.CDNImagePath

// GQL_GATEWAY is available at runtime and defines the URQL client endpoint.
// GRAPHQL_ENDPOINT is defined at build time in drone for use by Codegen. Both have the same value.
export const GQL_GATEWAY: string = services.gqlGateway
export const REFRESH_TOKEN_COOKIE_NAME: string = refreshTokenCookieName
export const JWT_COOKIE_NAME: string = jwtCookieName

export const BIZ_GUEST_ROLES: string[] = ['administrator', 'manager', 'member']
export const HOST_ROLES: string[] = ['host', 'blackbox_host']

export const PASSWORD_RESET_TOKEN: string = 'reset_password_token'
export const PASSWORD_RESET_EMAIL: string = 'email'

export const MAX_ENQUIRY_RESPONSES = 15

export const COLORS = {
  hbPrimary: '#AF231C',
  lightPrimary: '#ffe9e8',
  grey: 'whitesmoke',
  darkGrey: 'grey',
}

export const currencyMap: Record<string, string> = {
  AUD: '$',
  EUR: '€',
  GBP: '£',
}
